import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—July 2006" />
	<Old2005BlogPage>
		<h2>July 2006</h2>




		<h3 className="blogdate">
		Tuesday, July 18, 2006
		</h3>






		<h4 className="blogitemtitle">
		Fire twirling in Calgary? (reprise)
		</h4>





			<div className="blogitembody">
			Henry from <em>Oolong Tea House</em> in Kensington, Calgary, has published a cool set of photos from Oolong's 2nd birthday party (June 25, 2006)!<br /><br /><em>Oolong Tea House</em> is a magical spot in Kensington where you can find an amazing selection of loose teas! The atmosphere is great, winter or summer, and the staff are super cool! It's an independent business! And if you heard my last podcast, then you might imagine that I enjoy being an <em>Oolong Tea House</em> patron (I like organic and green rooibos).<br /><br />The following picture belongs to Henry; I resized it to fit this column. Click on the photo to see Henry's photos, and/or see the related links below! Note: Can you find Waldo... er... Jesse? He's wearing a green, <em>Food in the Belly</em> shirt.<br /><br /><a href="http://housemajor.com/gallery/main.php?g2_itemId=23789"><StaticImage
			src="../../images/photos/old2005BlogPics/20060718/DSCN6218_mod.JPG"
			alt="Oolong Tea House 2nd birthday party"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/></a>
			<br /><br />Related Links:<br /><ul><li><a href="http://housemajor.com/gallery/main.php?g2_itemId=23789">Henry's photos</a></li><li><a href="http://www.oolonghouse.com/">Oolong Tea House</a></li><li><a href="http://www.firetwirl.com.au/">Aaron and Fi and their fire twirling in Australia</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:28 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Monday, July 03, 2006
		</h3>






		<h4 className="blogitemtitle">
		Advice on working in Australia
		</h4>





			<div className="blogitembody">
			Going to Australia?  Plan on working there?  I'm assuming you already arranged for a visa or work permit.<br /><br />Get your <em>Tax File Number</em> (<strong>TFN</strong>), and open a bank account, immediately when you enter the country.  Do not wait.  Do it now.  You have to be in Australia... do it now if you are in Australia!<br /><br />The <strong>Big Question</strong> that appears on <em>Australian Taxation Office</em> (<strong>ATO</strong>) forms when you start a new job: <strong>are you an Australian resident for tax purposes?</strong>  The answer is <strong>NO</strong>.  If you think the answer is YES, then please <a href="http://www.ato.gov.au/individuals/content.asp?doc=/content/64131.htm">read here</a> before you completely commit to YES.  The difference between NO and YES is huge in terms of <a href="http://www.ato.gov.au/individuals/content.asp?doc=/content/12333.htm">tax rates</a> and withheld tax.  Everybody will tell you to say YES, and <a href="http://refunder.com.au/">The Refunder</a> will get you lots of your tax back if you claim you were a resident... but essentially, you may be lying to the Australian government.  You decide!<br /><br />When leaving an employment situation (i.e. a job), get the following<br /><ul><li>The <em>Australian Business Number</em> (<strong>ABN</strong>) of the employer who pays you</li><li>The full contact details for the employer</li><li>an official payment summary that outlines your TFN, total income, total superannuation witheld, and total tax withheld.  If they won't prepare one for you at that time, you will need to contact them near <em>tax time</em> to get one.</li></ul><p><em>Tax time</em> in Australia is July to October.</p>If you are skilled at particular trades, and plan to stay a while in Australia, then apply for your own ABN and buy an invoice/receipt book so you can give tax receipts.  Be a contractor!  Keep your business expense receipts, and your income record, and expect to hire an accountant to lodge your tax return.<br /><br />Note that coffee shops, restaurants, and bars probably won't hire a contractor, they want you to be an employee.  It depends on how talented you are, I suppose!  In my opinion, being a contractor, rather than an employee, is much preferred - nothing should be withheld, and you don't have to charge GST unless you are earning over 50 or 60 thousand dollars.  It's simple, really!<br /><br />
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 11:13 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Sunday, July 02, 2006
		</h3>






		<h4 className="blogitemtitle">
		Podcast: Indie Grocery Store
		</h4>





			<div className="blogitembody">
			I wrote this song a week ago!  This recording is a medley of <em>Indie Grocery Store</em> and <em>Let Me Be</em> (Xavier Rudd).  Check it out!  If you request this song at one of my live shows, I'll play it!<br /><ul><li><a href="/" onClick={doNothingAnchor}>(removed)</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:44 PM &nbsp;

			</div>





		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
